export default {"src":"/_next/static/media/Lock.79d9592a.svg","height":16,"width":16};